import React from 'react';
import { Form, Input, Button, Typography, Row, Col, Card, message } from 'antd';
import Layout from '../components/layout';
import { signup } from '../services/authService';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const SignupPage = () => {
  const navigate = useNavigate();

  const handleSignup = async (values) => {
    try {
      const { firstName, lastName, email, password, phone, username } = values;
      const data = await signup(firstName, lastName, email, password, phone, username);

      message.success('Signup successful! Please login.');
      navigate('/'); // Redirect to login page after successful signup
    } catch (error) {
      message.error(error.message || 'Signup failed. Please try again.');
    }
  };

  return (
    <Layout>
      <Row justify="center" align="middle" style={{ minHeight: '100vh', padding: '24px' }}>
        <Col xs={24} sm={16} md={12} lg={8}>
          <Card
            style={{
              padding: '24px',
              borderRadius: '8px',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            }}
            bordered
          >
            <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>
              User Signup
            </Title>
            <Form name="signupForm" layout="vertical" onFinish={handleSignup}>
              <Form.Item
                name="firstName"
                label="First Name"
                rules={[{ required: true, message: 'Please input your first name!' }]}
              >
                <Input placeholder="Enter your first name" />
              </Form.Item>

              <Form.Item
                name="lastName"
                label="Last Name"
                rules={[{ required: true, message: 'Please input your last name!' }]}
              >
                <Input placeholder="Enter your last name" />
              </Form.Item>

              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: 'Please input your email!' }]}
              >
                <Input type="email" placeholder="Enter your email" />
              </Form.Item>

              <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true, message: 'Please input your password!' }]}
              >
                <Input.Password placeholder="Enter your password" />
              </Form.Item>

              <Form.Item
                name="phone"
                label="Phone Number"
                rules={[{ required: true, message: 'Please input your phone number!' }]}
              >
                <Input placeholder="Enter your phone number" />
              </Form.Item>

              <Form.Item
                name="username"
                label="Username"
                rules={[{ required: true, message: 'Please input your username!' }]}
              >
                <Input placeholder="Enter your username" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Signup
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};

export default SignupPage;